import URLHandler from './URLHandler.js'

import collections from './collections/collections.json'

const locale = URLHandler.GetLocaleFromUrl()

const Get = (collectionString) => {
    return collections[locale][collectionString] || gon.collections[locale][collectionString]
}

const GetSortedCollection = (collectionString) => {
    return Get(collectionString).sort(
        (a, b) => a.name.localeCompare(b.name)
    )
}

const Translate = (collectionString, value) => {
    const result = Get(collectionString).find((element) => {
        return element.value === value
    })
    if (result) {
        return result.name
    }

    return '/'
}

const TranslateFromCollection = (collection, value) => {
    const result = collection.find((element) => {
        return element.value === value
    })
    if (result) {
        return result.name
    }

    return '/'
}

export default { Get, GetSortedCollection, Translate, TranslateFromCollection }
